module.exports = __webpack_public_path__ + "img/70.d967a70e.webp";